/* eslint-disable import/prefer-default-export */

export const isGTPGoal = (constants, goalUID) => {
  const gtpGoalsList = constants?.gtpGoals || constants?.GTP_GOALS;
  return gtpGoalsList?.includes(goalUID) || false;
};
